import React, { useState, useEffect, useRef } from 'react';
import './ImageModalOther.css';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';

interface ImageModalOtherProps {
  isOpen: boolean;
  onClose: () => void;
  eventName: string;
  eventId: number;
  onRefresh?: () => void;
}

const ImageModalOther: React.FC<ImageModalOtherProps> = ({
  isOpen,
  onClose,
  eventName,
  eventId,
  onRefresh,
}) => {
  const [newEventName, setNewEventName] = useState(eventName);
  const [isSaving, setIsSaving] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen && eventId) {
      axiosPrivate.get(`/events/${eventId}`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            const event = response.data[0];
            setNewEventName(event.Tytul ? event.Tytul + ' ' : ' ');
          }
        })
        .catch(error => {
          console.error("Błąd przy pobieraniu szczegółów wydarzenia:", error);
        });
    }
  }, [isOpen, eventId, axiosPrivate]);


 useEffect(() => {
    if (isOpen && inputRef.current) {
      const length = inputRef.current.value.length;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(length, length);
    }
  }, [isOpen]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewEventName(e.target.value);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const response = await axiosPrivate.put(`/events/${eventId}`, {
        title: newEventName,
      });
      if (onRefresh) onRefresh();
      onClose();
    } catch (error) {
      console.error('Błąd podczas zapisywania nazwy wydarzenia:', error);
      alert('Nie udało się zapisać zmian. Spróbuj ponownie.');
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="image-modal-overlay">
      <div className="image-modal-content">
        <button className="image-modal-close" onClick={onClose}>
          ✖
        </button>
        <h3>Edycja nazwy wydarzenia</h3>
        <input
          type="text"
          value={newEventName}
          onChange={handleNameChange}
          ref={inputRef}
          className="modal-input"
        />
        <div className="modal-buttons">
          <button className="custom-modal-button" onClick={handleSave} disabled={isSaving}>
            Zapisz
          </button>
          <button className="custom-modal-button" onClick={onClose}>
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModalOther;
